import { supabase } from '../supabase';

// Tela de E-mail: tudo passa por /api/email?acao=... (as caixas e o índice ficam trancados no banco;
// só o servidor lê e grava).
async function token() {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token || '';
}

export async function email(acao, dados = {}) {
  const r = await fetch(`/api/email?acao=${encodeURIComponent(acao)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${await token()}` },
    body: JSON.stringify(dados),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Erro ${r.status}`);
  return j;
}

/** Baixa um anexo (com o login) e abre/salva no navegador. */
export async function baixarAnexo(dados, nome, abrir) {
  const r = await fetch('/api/email?acao=anexo', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${await token()}` },
    body: JSON.stringify(dados),
  });
  if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.error || `Erro ${r.status}`); }
  const blob = await r.blob();
  const url = URL.createObjectURL(blob);
  if (abrir) window.open(url, '_blank', 'noopener');
  else {
    const a = document.createElement('a');
    a.href = url; a.download = nome || 'anexo';
    document.body.appendChild(a); a.click(); a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function arquivoParaBase64(arquivo) {
  return new Promise((ok, falha) => {
    const r = new FileReader();
    r.onload = () => ok(String(r.result).split(',')[1] || '');
    r.onerror = () => falha(new Error(`Não consegui ler ${arquivo.name}`));
    r.readAsDataURL(arquivo);
  });
}

export const tamanho = n => {
  if (!n && n !== 0) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
};

/** 14:32 (hoje) · ontem · 18/10 · 18/10/2025 */
export function quando(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const hoje = new Date();
  if (d.toDateString() === hoje.toDateString()) return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const ontem = new Date(hoje); ontem.setDate(hoje.getDate() - 1);
  if (d.toDateString() === ontem.toDateString()) return 'ontem';
  return d.getFullYear() === hoje.getFullYear()
    ? d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
    : d.toLocaleDateString('pt-BR');
}
export const dataHora = iso => (iso ? new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '');
/** '2026-10-21' → 'qua, 21/10' */
export function diaCurto(dataISO) {
  if (!dataISO) return '';
  const d = new Date(`${dataISO}T12:00:00`);
  return d.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit' }).replace('.', '');
}
export const nomeDe = p => (p ? (p.nome || p.email) : '');
/** HTML de e-mail recebido → seguro para pôr na página (resposta/encaminhar): sem scripts, eventos ou estilos globais. */
export function limparHtml(html) {
  const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
  doc.querySelectorAll('script,style,iframe,object,embed,form,input,button,select,textarea,link,meta,base,frame,frameset,svg,math').forEach(n => n.remove());
  doc.querySelectorAll('*').forEach(el => {
    for (const a of [...el.attributes]) {
      const nome = a.name.toLowerCase(), valor = String(a.value || '').trim().toLowerCase();
      if (nome.startsWith('on') || nome === 'srcdoc' || ((nome === 'href' || nome === 'src' || nome === 'action' || nome === 'xlink:href') && /^(javascript|vbscript|data:text)/.test(valor))) el.removeAttribute(a.name);
    }
  });
  return doc.body ? doc.body.innerHTML : '';
}
export const escapar = s => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
